(function ($) {
    'use strict';

    setSideNav();

    function setSideNav() {
       
        if($('.sub-nav').length == 1) {

            if($('.sub-nav .current').length == 1) {
                var grandParent = $('.sub-nav .current').closest('ul').parent('li');

                if(grandParent.length) {
                    grandParent.addClass('current');
                }

                var grandGP = grandParent.closest('ul').parent('li');

                if(grandGP.length) {
                    grandGP.addClass('current');
                }
            }
        } 
    }

}(jQuery));